import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styles from './Divider.module.scss'

const Divider = (props) => {
  const { className } = props
  const classes = classnames(
    styles.divider,
    className,
  )
  return (
    <div className={classes} />
  )
}

Divider.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

Divider.defaultProps = {
  className: '',
}

export default Divider



// WEBPACK FOOTER //
// ./src/components/Onboarding/Shared/Divider/Divider.jsx